module.exports = __webpack_public_path__ + "img/palani-grey-icon.7d02b17.webp";